export const contentDistribution = {
  "tab_name": "content-distribution",
  "data": [
    {
      "name": "Imperial College London",
      "data": [
        {
          "domain": "Academic Publications",
          "influence_score": 92,
          "citation_count": 74,
          "social_media_presence": 101,
          "research_impact": 83,
          "industry_collaborations": 87
        },
        {
          "domain": "Research Conferences",
          "influence_score": 88,
          "citation_count": 70,
          "social_media_presence": 97,
          "research_impact": 79,
          "industry_collaborations": 84
        },
        {
          "domain": "Industry Partnerships",
          "influence_score": 85,
          "citation_count": 68,
          "social_media_presence": 94,
          "research_impact": 77,
          "industry_collaborations": 81
        },
        {
          "domain": "Student Publications",
          "influence_score": 78,
          "citation_count": 62,
          "social_media_presence": 86,
          "research_impact": 70,
          "industry_collaborations": 74
        },
        {
          "domain": "Faculty Blogs",
          "influence_score": 82,
          "citation_count": 66,
          "social_media_presence": 90,
          "research_impact": 74,
          "industry_collaborations": 78
        }
      ]
    },
    {
      "name": "University of Oxford",
      "data": [
        {
          "domain": "Academic Publications",
          "influence_score": 95,
          "citation_count": 76,
          "social_media_presence": 105,
          "research_impact": 86,
          "industry_collaborations": 90
        },
        {
          "domain": "Research Conferences",
          "influence_score": 91,
          "citation_count": 73,
          "social_media_presence": 100,
          "research_impact": 82,
          "industry_collaborations": 86
        },
        {
          "domain": "Industry Partnerships",
          "influence_score": 87,
          "citation_count": 70,
          "social_media_presence": 96,
          "research_impact": 78,
          "industry_collaborations": 83
        },
        {
          "domain": "Student Publications",
          "influence_score": 81,
          "citation_count": 65,
          "social_media_presence": 89,
          "research_impact": 73,
          "industry_collaborations": 77
        },
        {
          "domain": "Faculty Blogs",
          "influence_score": 84,
          "citation_count": 67,
          "social_media_presence": 92,
          "research_impact": 76,
          "industry_collaborations": 80
        }
      ]
    },
    {
      "name": "University of Cambridge",
      "data": [
        {
          "domain": "Academic Publications",
          "influence_score": 93,
          "citation_count": 74,
          "social_media_presence": 102,
          "research_impact": 84,
          "industry_collaborations": 88
        },
        {
          "domain": "Research Conferences",
          "influence_score": 89,
          "citation_count": 71,
          "social_media_presence": 98,
          "research_impact": 80,
          "industry_collaborations": 85
        },
        {
          "domain": "Industry Partnerships",
          "influence_score": 86,
          "citation_count": 69,
          "social_media_presence": 95,
          "research_impact": 77,
          "industry_collaborations": 82
        },
        {
          "domain": "Student Publications",
          "influence_score": 79,
          "citation_count": 63,
          "social_media_presence": 87,
          "research_impact": 71,
          "industry_collaborations": 75
        },
        {
          "domain": "Faculty Blogs",
          "influence_score": 83,
          "citation_count": 66,
          "social_media_presence": 91,
          "research_impact": 75,
          "industry_collaborations": 79
        }
      ]
    },
    {
      "name": "London Business School",
      "data": [
        {
          "domain": "Academic Publications",
          "influence_score": 90,
          "citation_count": 72,
          "social_media_presence": 99,
          "research_impact": 81,
          "industry_collaborations": 86
        },
        {
          "domain": "Research Conferences",
          "influence_score": 87,
          "citation_count": 70,
          "social_media_presence": 96,
          "research_impact": 78,
          "industry_collaborations": 83
        },
        {
          "domain": "Industry Partnerships",
          "influence_score": 94,
          "citation_count": 75,
          "social_media_presence": 103,
          "research_impact": 85,
          "industry_collaborations": 89
        },
        {
          "domain": "Student Publications",
          "influence_score": 76,
          "citation_count": 61,
          "social_media_presence": 84,
          "research_impact": 68,
          "industry_collaborations": 72
        },
        {
          "domain": "Faculty Blogs",
          "influence_score": 81,
          "citation_count": 65,
          "social_media_presence": 89,
          "research_impact": 73,
          "industry_collaborations": 77
        }
      ]
    },
    {
      "name": "University of Manchester",
      "data": [
        {
          "domain": "Academic Publications",
          "influence_score": 85,
          "citation_count": 68,
          "social_media_presence": 94,
          "research_impact": 77,
          "industry_collaborations": 81
        },
        {
          "domain": "Research Conferences",
          "influence_score": 82,
          "citation_count": 66,
          "social_media_presence": 90,
          "research_impact": 74,
          "industry_collaborations": 78
        },
        {
          "domain": "Industry Partnerships",
          "influence_score": 79,
          "citation_count": 63,
          "social_media_presence": 87,
          "research_impact": 71,
          "industry_collaborations": 75
        },
        {
          "domain": "Student Publications",
          "influence_score": 73,
          "citation_count": 58,
          "social_media_presence": 80,
          "research_impact": 66,
          "industry_collaborations": 69
        },
        {
          "domain": "Faculty Blogs",
          "influence_score": 77,
          "citation_count": 62,
          "social_media_presence": 85,
          "research_impact": 69,
          "industry_collaborations": 73
        }
      ]
    }
  ],
  "evidence_sources": [
    {
      "category": "content_analysis",
      "source": "Content Distribution Analysis",
      "confidence": 0.90,
      "url": "https://www.imperial.ac.uk/research",
      "snippet": "Analysis of content distribution across various academic and digital platforms.",
      "type": "content_analysis",
      "domain": "education"
    },
    {
      "category": "research_impact",
      "source": "Research Impact Metrics",
      "confidence": 0.85,
      "url": "https://scholar.google.com",
      "snippet": "Citation and research impact analysis for academic publications.",
      "type": "academic",
      "domain": "research"
    }
  ],
  "recommendations": [
    {
      "category": "content_strategy",
      "issue": "Content Distribution Optimization",
      "recommendation": "Improve content distribution across multiple platforms to increase visibility",
      "priority": "High",
      "expected_impact": "Enhanced content reach and engagement across platforms"
    },
    {
      "category": "research_visibility",
      "issue": "Research Impact Enhancement",
      "recommendation": "Focus on high-impact publications and conference presentations",
      "priority": "Medium",
      "expected_impact": "Improved research visibility and citation rates"
    }
  ],
  "cached": true,
  "timestamp": "2025-08-19T18:31:03.135672",
  "models_used": [
    "chatgpt"
  ],
  "plan_type": "university_paid"
};
